<template>
  <div class="container" data-dashBoardLock="true" :style="{ height: heightContainer}">
    <div  class="aside-user" v-if="!showNav && userData && !mobileMode">
      <span class="aside-user__initials">{{initialsFunc(userData.name)}}</span>

      <img class="aside-user__img" 
        :src="'https://college.instudy.online/img/mgok/avatar/'+userData.id+'.jpg'"
          onerror="this.onerror=null;this.style.display = 'none';">
      <span class="aside-user__name">{{userData ? userData.name : ''}}</span>
    </div>

    <transition name="fade">
      <modal v-if="modalData"></modal>
    </transition>

    <transition name="fade">
      <loadingIcon v-if="loadingIcon"/>
    </transition>

    <navigation v-if="!showNav && !mobileMode"/>

    <navigation-mobile v-if="!showNav && mobileMode"/>

    <main id="content" :class="[showNav ? 'contentAuth' : 'content']">
  
    <transition name="router-animation">
      <router-view/>
    </transition>
  </main>
  </div>
</template>
<script>
import modal from './components/modal'
import {mapMutations, mapState} from 'vuex'
import navigation from './components/navigation'
import loadingIcon from './components/loadingIcon'
import NavigationMobile from './components/navigationMobile.vue'
export default {
  name: 'App',
  data() {
    return {
      
      userData: this.$store.state.auth.user,
      loading: this.$store.getters.loadingIconStatus,
    }
  },
  components:{
    navigation,
    loadingIcon,
    modal,
    'navigation-mobile':NavigationMobile
  },
  methods:{
    ...mapMutations(['setMobileMode', 'updateAuth', 'setWidthWindow', 'setEnterPoint']),
    initialsFunc(val){
        let arr = val.split(' ')
        let a = arr[0][0]
        let b = arr[1][0] ==='(' ? arr[2][0] : arr[1][0]
        return a+b
      },
    checkMobileMode(){
      window.innerWidth > 800 ? this.setMobileMode(false) : this.setMobileMode(true)
    },
  },
  computed:{
      ...mapState(['loadingIcon']),
      modalData(){
        return this.$store.state.modalData
      },
      showNav(){
        return this.$route.meta.fullScreen
      },
      heightContainer(){
        if(this.mobileMode){
          return window.innerHeight+'px'
        }else{
          return '100vh'
        } 
      },
      mobileMode(){
        return this.$store.state.mobileMode
      }
  }, 

  mounted() {
    this.checkMobileMode()
    this.$store.state.currentRoute = this.$route.path
    window.addEventListener('resize', ()=>{
      this.setWidthWindow(window.innerWidth)
      this.checkMobileMode()
    })
    this.setEnterPoint(this.globalFunctions.setEnterPoint(window.location.origin))
  },
}
</script>
<style lang="scss">
  .container{
    transition-duration: 0.3s;
    transition-property: background-color;
    display: flex;
    height: 100vh;
    overflow: hidden;
    position: relative;
    width: 100% !important;
  }
  .aside-user{
    cursor: pointer;
    display: flex;
    display: none;
    align-items: center;
    justify-content: start;
    transition-duration: 0.3s;
    padding: 10px;
    border-radius: 40px 0 0 40px;
    border: 2px solid $basic-white;
    border-right-color: transparent;
    z-index: 3;
    width: 80px;
    height: 80px;
    position: fixed;
    right: 0;
    top: 20px;
    background-color: $brand-clr-1;
    &:hover{
      width: 280px;
    }
  }
  .aside-user__img{
    border-radius: 50%;
    height: 60px;
  }
  .aside-user__name{
    font-size: 16px;
    display: block;
    width: min-content;
    word-wrap: break-all;
    color: $basic-white;
    padding: 0 10px;
  }
  .aside-user__initials{
      border-radius: 50%;
      background-color: $placeholder-text-clr;
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 25px;
    }
  .content{
    position: relative;
    overflow-y: auto;
    padding: 20px 20px 20px 20px;
    height: 100%;
    width: 100%;
  }
  .contentAuth{
    position: relative;
    height: 100%;
    width: 100%;
  }
  
  .router-animation-enter-active{
    animation: coming 0.3s;
    animation-delay: 0.3s;
    opacity: 0;
  }
  .router-animation-leave-active{
    animation: going 0.3s;
  }
  @keyframes going {
    from{
      transform: translateY(0);
      opacity: 1;
    }
    to{
      transform: translateY(-100vh);
      opacity: 0;
    }
  }
  @keyframes coming {
    from{
      transform: translateX(-100%);
      opacity: 0;
    }
    to{
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media (max-width: 800px) {
    .container{
      flex-wrap: wrap;
      //display: grid;
      //grid-template-rows: repeat(2, auto);
      .content-wrp{
        border-radius: 0;
      }
      .content{
        padding-top: 60px;
      }
    }
  }
</style>
